import { Price } from '@spartacus/core';

export interface InvoiceSummaryResponse {
    invoiceNumber?:string,
    accountingDocumentNumber?:string,
    companyCode?:string,
    bookingTime?:number,
    bookingYear?:number,
    invoiceDate?:Date,
    dueDate?:Date,
    amount?:number,
    amountFormattedValue?:string,
    debitOrCredit?:string,
    deliveryStatus?:string,
    notificationNumber?:string,
    notificationDate?:Date,
    discount?:number,
    discountFormattedValue?:string,
    collectedAmount?:number,
    collectedAmountFormattedValue?:string,
    currency?:string,
    invoiceStatus?:string,
    accumulatedValue?:number,
    accumulatedFormattedValue?:string,
    pdfUrl?:string,
    deliveryPdfUrl?:string,
    referenceNumber?:string
}

export interface BalanceResponse {
    balanceWarehouse?:string,
    balanceWarehouseStatus?:string,
    balanceThirdParty?:string,
    balanceThirdPartyStatus?:string,
    balanceValue?:string,
    balanceValueStatus?:string
}

export interface InvoiceHistory {
    invoices?: InvoiceSummaryResponse[],
    balance?: BalanceResponse
}

export interface InvoiceSummaryDetailResponse {
    invoiceNumber?:string,
    invoiceDate?:Date,
    formattedInvoiceDate?:string,
    entries?:InvoiceSummaryDetailEntryResponse[]
}

export interface InvoiceSummaryDetailEntryResponse {
    delivery?:string,
    sales?:string,
    receivedDate?:Date,
    formattedReceivedDate?:string,
    valueDate?:Date,
    formattedValueDate?:string,
    partnerFunction?:string,
    customerNumber?:string,
    title?:string,
    name1?:string,
    name2?:string,
    name3?:string,
    name4?:string,
    street?:string,
    houseNumber?:string,
    houseNumberSupplement?:string,
    postalCode?:string,
    poxBoxPostalCode?:string,
    companyPostalCode?:string,
    city?:string,
    district?:string,
    textForPartners?:string,
    grossValue?:number,
    grossValuePriceData?:Price,
    rate1?:number,
    formattedRate1?:string,
    condition1Value?:number,
    formattedCondition1Value?:string,
    rate2?:number,
    formattedRate2?:string,
    condition2Value?:number,
    formattedCondition2Value?:string,
    netValue?:number,
    netValuePriceData?:Price,
    taxAmount?:number,
    formattedTaxAmount?:string,
    currency?:string,
    rateUnit?:string,
    conditionValue?:number,
    formattedConditionValue?:string
}

export interface InvoiceSummaryAvisResponse {
    avisNumber?:string,
    avisDate?:Date,
    formattedAvisDate?:string,
    balance?:number,
    balancePriceData?:Price,
    debitIndicator?:string,
    cashDiscountAmount?:number,
    cashDiscountAmountPriceData?:Price,
    plannedAmount?:number,
    plannedAmountPriceData?:Price,
    currencyKey?:string,
    entries?:InvoiceSummaryAvisEntryResponse[]
}

export interface InvoiceSummaryAvisEntryResponse {
    warehouse?:string,
    billingDocument?:string,
    accountingDocumentNumber?:string,
    companyCode?:string,
    fiscalYear?:number,
    numberOfLine?:number,
    billingDate?:Date,
    formattedBillingDate?:string,
    dueDate?:Date,
    formattedDueDate?:string,
    amount?:number,
    amountPriceData?:Price,
    debitIndicator?:string,
    cashDiscountAmount?:number,
    cashDiscountAmountPriceData?:Price,
    plannedAmount?:number,
    plannedAmountPriceData?:Price,
    currencyKey?:string,
    reverseDocumentNumber?:string,
    reverseDocumentFiscalYear?:number,
    flaggedForReversal?:string,
    reversalDoc?:string,
    identifierReversalDoc?:string,
    hasBeenReversed?:string
}

export enum InvoiceSortOptions {
    invoiceNumber,
    referenceNumber,
    invoiceDate,
    dueDate,
    amount,
    debitOrCredit,
    deliveryStatus,
    notificationNumber,
    notificationDate,
    discount,
    collectedAmount,
    accumulatedValue
}

export enum BookingType {
    ALL,
    DEBIT,
    CREDIT
}

export enum OrderType {
    ALL,
    CAMP,
    ROUTE
}

export interface InvoiceHistoryRequestData {
    dateFrom?: string,
    dateTo?: string,
    invoiceNumber?: string,
    articleNumber?: string,
    adviceNumber?: string,
    onlyOpen?: Boolean,
    referenceNumber?: string,
    amountFrom?: string,
    amountTo?: string,
    orderType?: string,
    bookingType?: string,
    sortOption?: string, 
    sortDirection?: string
}